module.exports = __webpack_public_path__ + "media/clip_6.469d1e40.mp4";